export default __webpack_public_path__ + "rpl_icon_dark.e80ba772.svg";